import * as echarts from 'echarts';

export const formatAxis = (
  axisData: (string | number)[],
  isHorizontal: boolean = false
) => {
  const valueType = 'value' as echarts.Axis['type'];
  const categoryType = 'category' as echarts.Axis['type'];

  return isHorizontal
    ? {
        xAxis: {
          type: valueType,
        },
        yAxis: {
          type: categoryType,
          data: axisData,
        },
      }
    : {
        xAxis: {
          type: categoryType,
          data: axisData,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          type: valueType,
        },
      };
};
